import BasePcWorkbenchSetting from '@framework/workbench/setting/base/base-pc-setting';
import { WorkbenchMenuSchema, WorkbenchTitlebarSchema, WorkbenchToolbarSchema } from '@tencent/workbench';
import { Slide } from '@tencent/docs-titlebar-service';
import { MENU_SCHEMA } from '@framework/workbench/schema/menu-schema/toc';
import { TOOLBAR_SCHEMA } from '@framework/workbench/schema/toolbar-schema/toc';
import { QuickToolController } from '@framework/workbench/ui/quick-setting/wrapper/quick-tool-controller';
import { UniformFontController } from '@framework/workbench/ui/quick-setting/uniform-font/uniform-font-controller';
import { VipLinkTextController } from '@framework/workbench/ui/quick-setting/vip-link-text/vip-link-text-controller';
import { ReplaceFontController } from '@framework/workbench/ui/quick-setting/replace-font/replace-font-controller';
import {
    MutiPicturePosController,
} from '@framework/workbench/ui/quick-setting/muti-picture-pos/muti-picture-pos-controller';
import {
    TextDesensitizationController,
} from '@framework/workbench/ui/quick-setting/text-desensitization/text-desensitization-controller';
import {
    MutiPictureExportController,
} from '@framework/workbench/ui/quick-setting/muti-picture-export/muti-picture-export-controller';
import { FontHandlerController } from '@framework/workbench/ui/quick-setting/font-handle-title/controller';
import { PicHandlerController } from '@framework/workbench/ui/quick-setting/pic-handle-title/controller';
import {
    MutiPictureSizeController,
} from '@framework/workbench/ui/quick-setting/muti-picture-size/muti-picture-size-controller';
import { InsertAddonController } from '@framework/workbench/ui/insert/insert-addon/insert-addon-controller';
import { InsertLatexController } from '@framework/workbench/ui/insert/insert-latex/insert-latex-controller';
import { AddonUnofficialController } from '@framework/workbench/ui/addon_unofficial/addon-unofficial-controller';
import { InsertDocTextController } from '@framework/workbench/ui/insert/insert-doc-text/insert-doc-text-controller';
import {
    InsertUploadLocalFileController,
} from '@framework/workbench/ui/insert/insert-upload-local-file/insert-upload-local-file-controller';
import { FileInfoController } from '@framework/workbench/ui/file-info-panel/file-info-panel-controller';
import { ExportFileController } from '@framework/workbench/ui/export-file/export-file-controller';
import { PrintController } from '@framework/workbench/ui/print/print-controller';
import { SaveRevisionController } from '@framework/workbench/ui/save-revision/save-revision-controller';
import { ExitDocumentController } from '@framework/workbench/ui/exit-document/exit-document-controller';
import { WaterMarkController } from '@framework/workbench/ui/water-mark/water-mark-controller';
import {
    ImportLocalSlideController,
} from '@framework/workbench/ui/import-slide/import-local-slide/import-local-slide-controller';
import {
    ImportOnlineSlideController,
} from '@framework/workbench/ui/import-slide/import-online-slide/import-online-slide-controller';
import { CertificationController } from '@framework/workbench/ui/certification/certification-controller';
import { AddonMallController } from '@framework/workbench/ui/addon_mall/addon-mall-controller';
import { TitleHighLightController } from '@framework/workbench/ui/title-highlight/title-highlight-controller';
import { LocalFileFolderController } from '@framework/workbench/ui/local-file-folder/file-folder-controller';
import { ExportImageController } from '@framework/workbench/ui/export-image/export-image-controller';
import { PdfTransformController } from '@framework/workbench/ui/pdf-transform/pdf-transform-controller';
import { AuthController } from '@framework/workbench/ui/auth/auth-controller';
import { LocalFileSaveAsController } from '@framework/workbench/ui/local-file-save-as/save-as-controller';
import '@tencent/docs-titlebar-service/dist/index.css';
import { TitleBarController } from '@framework/workbench/ui/titlebar/titlebar-controller';
import { AnonymousViewController } from '@framework/workbench/ui/anonymous-view/anonymous-view-controller';
import { TableTabController } from '@framework/workbench/ui/table-tab/table-tab-controller';
import { RatingController } from '@framework/workbench/ui/quick-setting/rating/rating-controller';
import { AiReviewController } from '@framework/workbench/ui/ai-review/ai-review-controller';
import { FileCompressionController } from '@framework/workbench/ui/file-compression/file-compression-controller';
import { InsertCommentController } from '@framework/workbench/ui/comment/insert-comment/insert-comment-controller';
import { DeleteCommentController } from '@framework/workbench/ui/comment/delete-comment/delete-comment-controller';
import { JumpToPrevCommentController } from '@framework/workbench/ui/comment/jump-to-prev-comment/jump-to-prev-comment-controller';
import { JumpToNextCommentController } from '@framework/workbench/ui/comment/jump-to-next-comment/jump-to-next-comment-controller';
import { ShowCommentController } from '@framework/workbench/ui/comment/show-comment/show-comment-controller';
import { ShowCommentAnchorController } from '@framework/workbench/ui/comment/show-comment-anchor/show-comment-anchor-controller';
import { ShowCommentNotifyFlagController } from '@framework/workbench/ui/comment/show-comment-notify-flag/show-comment-notify-flag-controller';
import { AddRevisionController } from '@framework/workbench/ui/add-revision/add-revision-controller';
import { MachineCheckController } from '@src/framework/workbench/ui/quick-setting/machine-audit/machine-audit-controller';
import { AiMenuController } from '@framework/workbench/ui/titlebar/ai-menu/ai-menu-controller';

export default class TocPcWorkbenchSetting extends BasePcWorkbenchSetting {
    protected getController(): Function[] {
        return [
            ...super.getController(),
            Slide.TitlebarController,
            TitleBarController,
            AiMenuController,
            QuickToolController,
            UniformFontController,
            RatingController,
            AiReviewController,
            VipLinkTextController,
            ReplaceFontController,
            MutiPicturePosController,
            TextDesensitizationController,
            MutiPictureExportController,
            FontHandlerController,
            PicHandlerController,
            MachineCheckController,
            MutiPictureSizeController,
            InsertAddonController,
            InsertLatexController,
            AddonUnofficialController,
            InsertDocTextController,
            InsertUploadLocalFileController,
            FileInfoController,
            ExportFileController,
            PrintController,
            SaveRevisionController,
            AddRevisionController,
            AuthController,
            ExitDocumentController,
            WaterMarkController,
            ImportLocalSlideController,
            ImportOnlineSlideController,
            CertificationController,
            AddonMallController,
            TitleHighLightController,
            AnonymousViewController,
            LocalFileSaveAsController,
            LocalFileFolderController,
            ExportImageController,
            PdfTransformController,
            TableTabController,
            InsertCommentController,
            DeleteCommentController,
            JumpToPrevCommentController,
            JumpToNextCommentController,
            ShowCommentController,
            ShowCommentAnchorController,
            ShowCommentNotifyFlagController,
            FileCompressionController,
        ];
    }

    /**
     * 获取menu schema，子类实现
     * @protected
     */
    protected getMenuSchema(): WorkbenchMenuSchema {
        return MENU_SCHEMA;
    }

    /**
     * 获取tool bar schema，子类实现
     * @protected
     */
    protected getToolBarSchema(): WorkbenchToolbarSchema {
        return TOOLBAR_SCHEMA;
    }

    /**
     * 获取titlebar schema，子类实现
     * @protected
     */
    protected getTitleBarSchema(): WorkbenchTitlebarSchema {
        return Slide.TITLEBAR_SCHEMA;
    }
}
